import { cn } from '@/lib/cn';
import { TONE_BAR, type Tone } from '@/lib/status';

/** Horizontal progress/share bar (channel splits, MAPE bars). */
export function ProgressBar({
  value,
  max,
  tone = 'primary',
  className,
  trackClassName,
}: {
  value: number;
  max: number;
  tone?: Tone;
  className?: string;
  trackClassName?: string;
}) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div className={cn('h-2 w-full overflow-hidden rounded-full bg-hover', trackClassName)}>
      <div className={cn('h-full rounded-full transition-all', TONE_BAR[tone], className)} style={{ width: `${pct}%` }} />
    </div>
  );
}
